import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { auditReports } from '@mi-front/api-clients';
import { MrtTable, SwitchInput } from '@mi-front/ui';
import { Box, Paper } from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { FormattedMessage } from 'react-intl';
import { useGipReportResultFilter_v2 } from './useGipReportResultFilter';
import { useGipResultColumnsFactory } from './useGipResultColumnsFactory';

interface Props {
  schedules: auditReports.GipReportMatchedScheduleDto[];
}

export const GipReportMatchedSchedulesView = ({ schedules }: Props) => {
  const columns = useGipResultColumnsFactory();
  const showScheduleDatetimeColumn = useFeatureIsOn('app__audit_gip_show_schedule_datetime_column');

  const { showOffTolerance, setShowOffTolerance, filteredItems } =
    useGipReportResultFilter_v2(schedules);

  const tableColumns = [
    columns.station,
    columns.matchDateTime,
    ...(showScheduleDatetimeColumn ? [columns.dateTime] : []),
    columns.advertiser,
    columns.campaign,
    columns.version,
    columns.customId,
    columns.contract,
    columns.order,
    columns.offToleranceIndicator,
    columns.actions,
  ].filter(Boolean) as unknown as MRT_ColumnDef<auditReports.GipReportMatchedScheduleDto>[];

  return (
    <>
      <Paper>
        <Box p={1} mb={2} mt={2} fontSize="0.875rem" display="flex" alignItems="center">
          <SwitchInput
            size="sm"
            checked={showOffTolerance}
            onChange={setShowOffTolerance}
            label={
              <FormattedMessage
                id="audit.gipReport.result.showOffTolerance"
                defaultMessage="Mostrar resultados fuera de tolerancia"
              />
            }
            style={{ margin: 0 }}
          />
        </Box>
      </Paper>

      <MrtTable<auditReports.GipReportMatchedScheduleDto>
        data={filteredItems}
        columns={tableColumns}
        muiTableBodyCellProps={({ row }) => {
          const match = row.original.match;

          const classes =
            match?.matchedScheduleConfirmationType === 'OFF_TOLERANCE' ? 'text-yellow' : '';

          return {
            classes: {
              root: classes,
            },
          };
        }}
      />
    </>
  );
};
